import styled from 'styled-components';
import { h6Styles } from 'utils/resuable-css';
import { variables } from 'variables';

export const CreateTicketStep3SC = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.pageBackgroundColor};
  padding: ${variables.pageContentPadding}px;
  padding-top: 70px;
  width: 100%;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const SubmitReply = styled.div`
  margin-top: 1em;
  margin-bottom: 2em;
`;

export const TextArea = styled.div`
  margin-top: 2em;
  textarea {
    width: 31.3em;
    font-size: ${(props) => props.theme.default?.h6};
    ${(props) => h6Styles(props.theme.resolutions)};
    border: 2px solid lightgray;
    border-bottom: 2px solid ${(props) => props.theme.primaryDarkColor};
    border-radius: 5px;
    resize: none;
    padding: 10px;
  }
`;
